// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loginerror[data-v-28a4765e] {\n  color: #ff5252;\n}\n.loginerror div[data-v-28a4765e]:first-child {\n  display: block;\n  margin: auto;\n}\nh2[data-v-28a4765e] {\n  margin-top: 2rem;\n}\nh4[data-v-28a4765e] {\n  margin-top: 2rem;\n}", ""]);
// Exports
module.exports = exports;
